<div class="main-container">
  <video class="home-video" preload="none" muted loop autoplay playsinline>
    <source src="bg1.mp4" type="video/mp4">
  </video>
  <div class="overlay"></div>
  <div class="pattern"></div>
  <div class="message-container">
    <div class="message error-message">Failed to link Social Account.We are investigating.</div>
  </div>
</div>
